import React from 'react';
export function ClosingSection() {
  return <section className="w-full bg-[#0a0a0a] py-10 md:py-16 px-4 border-t border-gray-800" data-id="element-44">
      <div className="max-w-2xl mx-auto text-center" data-id="element-45">
        <h2 className="text-2xl md:text-4xl font-black text-white mb-2 leading-tight" data-id="element-46">
          La diferencia entre intentarlo
        </h2>
        <p className="text-2xl md:text-4xl font-black text-[#c41e3a] mb-8 leading-tight" data-id="element-47">
          y hacerlo en serio.
        </p>

        <div className="w-16 h-0.5 bg-[#c41e3a] mx-auto mb-8" data-id="element-48"></div>

        <div className="space-y-4 mb-10" data-id="element-49">
          <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-lg mx-auto" data-id="element-50">
            Podés seguir viendo contenido suelto y aprender lentamente.
          </p>
          <p className="text-gray-200 text-base md:text-lg font-semibold leading-relaxed max-w-lg mx-auto" data-id="element-51">
            O podés seguir un método estructurado que te guíe paso a paso.
          </p>
          <p className="text-white font-black text-lg md:text-xl mt-6 bg-[#111] p-4 rounded-lg border border-gray-800 inline-block" data-id="element-52">
            Método Barber Pro está pensado para quienes quieren aprender
            barbería de verdad.
          </p>
        </div>

        <div className="flex flex-col items-center gap-3" data-id="element-53">
          <a href="#pricing" className="cta-primary text-white font-black text-base md:text-xl px-10 md:px-14 py-4 md:py-5 rounded-lg inline-block text-center" aria-label="Empezar ahora" data-id="element-54">
            👉 EMPEZAR AHORA
          </a>
        </div>
      </div>
    </section>;
}